function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* 审批轨迹相关方法 */
import data from './data';

export default {
  mixins: [data],
  methods: {
    // 获取流程轨迹
    getApprovalTrack: function getApprovalTrack() {
      var _this = this;

      this.$store.dispatch('postRequest', {
        url: 'bsp-bpm/bpm/approveProcess/approveTrack',
        params: { actInstId: this.actInstId }
      }).then(function (resp) {
        if (resp.success) {
          if (!resp.data) return;
          resp.data.map(function (item) {
            if (item.createTime) {
              if (item.endTime) {
                item.taskStatus = '2';
              } else {
                item.taskStatus = '1';
              }
            } else {
              item.taskStatus = '0';
            }
          });
          _this.trackArr = resp.data;
        } else {
          _this.trackArr = [];
        }
      });
    },

    // 撤回流程
    revoke: function revoke(taskId, preIsBeginTask) {
      var _this2 = this;

      this.$Modal.confirm({
        title: '是否确认撤回？',
        // loading: true,
        onOk: function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this2.loading = true;
                    _this2.$store.dispatch('postRequest', {
                      url: 'bsp-bpm/bpm/approveProcess/revokeProcess',
                      params: { actInstId: _this2.actInstId, taskId: taskId, preIsBeginTask: preIsBeginTask }
                    }).then(function (resp) {
                      if (resp.success) {
                        if (_this2.revokeCallback) {
                          _this2.revokeCallback(resp).then(function (data) {
                            _this2.loading = false;
                            if (data.success) {
                              // window.location.reload()
                              _this2.getApprovalTrack();
                            }
                          });
                        } else {
                          _this2.loading = false;
                          _this2.$Modal.success({
                            title: '温馨提示',
                            content: '操作成功',
                            onOk: function onOk() {
                              // window.location.reload()
                              _this2.getApprovalTrack();
                            }
                          });
                        }
                      }
                    });

                  case 2:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function onOk() {
            return _ref.apply(this, arguments);
          };
        }()
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/flow-general-history/mixins/track-methods.js
// module id = 10
// module chunks = 0